import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BackgroundManager = () => {
  const location = useLocation();

  useEffect(() => {
    // List of routes that should have the simple background
    const simpleBgRoutes = [
      '/login',
      '/onboarding/platform',
      '/onboarding/username', 
      '/onboarding/leagues',
      '/onboarding/auth',
      '/onboarding/plan',
      '/check-your-email',
      '/waitlist',
      '/waitlist-no-access',
      '/no-access',
      '/select-account',
      '/subscription-confirmation',
      '/invite',
      '/invite-signup',
      '/league-context',
      '/weekly-context'
    ];

    // Check if current route should have simple background
    const shouldHaveSimpleBg = simpleBgRoutes.some(route => 
      location.pathname === route || location.pathname.startsWith(route + '/')
    );

    // Add or remove the simple-bg class
    if (shouldHaveSimpleBg) {
      document.body.classList.add('simple-bg');
    } else {
      document.body.classList.remove('simple-bg');
    }

    // Cleanup function
    return () => {
      document.body.classList.remove('simple-bg');
    };
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default BackgroundManager;
